var _svg;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ClimaLight = function ClimaLight(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _svg || (_svg = /*#__PURE__*/_jsx("svg", {
      width: "24",
      height: "24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsxs("g", {
        fill: "currentColor",
        children: [/*#__PURE__*/_jsx("path", {
          opacity: ".4",
          d: "M4.383 6.984a3.327 3.327 0 0 0 0 4.725l7.612 7.613 4.725-4.725-7.612-7.613a3.327 3.327 0 0 0-4.725 0Z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M17.246 12.673a3.325 3.325 0 1 0 0-6.65 3.325 3.325 0 0 0 0 6.65ZM6.746 12.673a3.325 3.325 0 1 0 0-6.65 3.325 3.325 0 0 0 0 6.65Z"
        })]
      })
    }))
  });
};
export default ClimaLight;